import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';
import './App.css';
import { observeUser, logout } from './services/authService';
import Login from './components/Login';

// Komponenten importieren
import Dashboard from './components/Dashboard';
import Dienstplan from './components/Dienstplan';
import Staffomatic from './components/Staffomatic';
import FreiwuenscheUrlaub from './components/FreiwuenscheUrlaub';
import Staerkemeldung from './components/Staerkemeldung';
import Dienstuebergabe from './components/Dienstuebergabe';
import Aufgaben from './components/Aufgaben';
import Feuerloescher from './components/Feuerloescher';
import EngeRaeume from './components/EngeRaeume';
import Berichte from './components/Berichte';
import ChangePassword from './views/ChangePassword';
import Speicherorte from './components/Speicherorte';
import Benutzerverwaltung from './components/Benutzerverwaltung';
import MobileSignaturePage from './components/MobileSignaturePage';
import Sidebar from "./components/Sidebar";
import SidebarSettingsPanel from './components/SidebarSettingsPanel';
import { UserProvider, useUser } from './UserContext';
import { ProjektProvider } from './contexts/ProjektContext';
import { getCurrentUser } from './services/firebaseAuthService';
import Einstellungen from './components/Einstellungen';
import TopBar from './components/TopBar';
import Projekte from './components/Projekte';

function AppContent() {
  const { user, setUser } = useUser();
  const [showSidebarSettings, setShowSidebarSettings] = React.useState(false);
  const [showProjekte, setShowProjekte] = React.useState(false);
  const location = useLocation();

  useEffect(() => {
    const unsubscribe = observeUser(async (authUser) => {
      if (authUser) {
        const userData = await getCurrentUser();
        setUser(userData);
      } else {
        setUser(null);
      }
    });
    return () => unsubscribe();
  }, [setUser]);

  if (user === undefined) {
    return <div>Lade...</div>;
  }

  if (!user) {
    return <Login />;
  }

  const handleLogout = async (e) => {
    e.preventDefault();
    await logout();
  };

  return (
      <div className="main-layout">
        <Sidebar />
        {location.pathname === '/einstellungen' ? (
          <div className="main-content">
            <TopBar 
              onSidebarSettingsClick={() => { setShowSidebarSettings((v) => !v); setShowProjekte(false); }}
              sidebarSettingsActive={showSidebarSettings}
              onProjekteClick={() => { setShowProjekte((v) => !v); setShowSidebarSettings(false); }}
              projekteActive={showProjekte}
            />
            {showSidebarSettings && <SidebarSettingsPanel />}
            {showProjekte && <Projekte />}
          </div>
        ) : (
          <div className="main-content">
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/dienstplan" element={<Dienstplan />} />
              <Route path="/staffomatic" element={<Staffomatic />} />
              <Route path="/freiwuensche-urlaub" element={<FreiwuenscheUrlaub />} />
              <Route path="/staerkemeldung" element={<Staerkemeldung />} />
              <Route path="/dienstuebergabe" element={<Dienstuebergabe />} />
              <Route path="/aufgaben" element={<Aufgaben />} />
              <Route path="/feuerloescher" element={<Feuerloescher />} />
              <Route path="/enge-raeume" element={<EngeRaeume />} />
              <Route path="/berichte" element={<Berichte />} />
              <Route path="/passwort" element={<ChangePassword />} />
              <Route path="/speicherorte" element={<Speicherorte />} />
              <Route path="/benutzerverwaltung" element={<Benutzerverwaltung />} />
              <Route path="/mobile-signature" element={<MobileSignaturePage />} />
              <Route path="/einstellungen" element={<Einstellungen />} />
            </Routes>
          </div>
        )}
      </div>
  );
}

function App() {
  return (
    <Router>
      <UserProvider>
        <ProjektProvider>
          <AppContent />
        </ProjektProvider>
      </UserProvider>
    </Router>
  );
}

export default App;
